export const DEFAULT_SECTIONS_COUNT = 2;
